<div class="height-100 flex-column wrap flex-middle">
    <!-- User Icon -->
    <div class="bg-col-w b-radius-max box-shadow-1">
        <i [ngClass]="content.successUserIcon"
           class="p-a-3 inline-flex"
           style="font-size: 24px;"></i>
    </div>

    <p *iCms="'successTitle' of content; content: 'html'"
       class="h3 m-t-3 center"></p>

    @if (mission.rosettes) {
    <i class="icon-rosette inline-flex m-t-9"
       style="font-size: 32px;"></i>
    <p class="p2 col-11 m-t-2">
        {{' You earned % Rosettes' | translate : mission.rosettes }}
    </p>
    }

    @if (mission.points) {
    <i class="icon-coins inline-flex m-t"
       style="font-size: 32px;"></i>
    <p class="p2 col-11 m-t-2 center"
       [innerHTML]="'You won % coins for <br> completing this mission' | translate : mission.points">
    </p>
    }

    <a class="button w-12 m-t-12"
       [routerLink]="'/'">
        <span *iCms="'successButtonText' of content"></span>
    </a>

    <div class="w-12 center m-t-5">
        <a class="button-inline-2"
           [routerLink]="'/account'">
            <span *iCms="'accountButtonText' of content"></span>
        </a>
    </div>
</div>
